import { Component, Input, OnInit } from "@angular/core";

@Component({
    selector: "app-skeleton-loader",
    template: ` <div [ngStyle]="getMyStyles()" class="skelt-load loader"></div> `,
    styleUrls: ["./skeleton-loader.component.scss"]
})
export class SkeletonLoaderComponent implements OnInit {
    @Input() Cwidth;
    @Input() Cheight;
    @Input() circle: boolean;
    @Input() Wporcent: boolean = false;

    constructor() {}

    ngOnInit(): void {}

    getMyStyles() {
        const myStyles = !this.Wporcent
            ? {
                  width: this.Cwidth ? this.Cwidth : "",
                  height: this.Cheight ? this.Cheight : "",
                  "border-radius": this.circle ? "50%" : ""
              }
            : {
                  "min-width": this.Cwidth ? this.Cwidth : "0px",
                  height: this.Cheight ? this.Cheight : "",
                  "border-radius": this.circle ? "50%" : ""
              };
        return myStyles;
    }
}
